/**
 * Read a figure typed by a person. Indian grouping ("5,00,000") and stray
 * spaces are normal input, and Number() turns both into NaN, which JSON then
 * sends as null and the server reads as "clear this value".
 *
 * Returns null for a blank entry, NaN for anything that is not a number, and
 * the number otherwise. Callers must check Number.isFinite before sending.
 */
export function parseNumber(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;
  const text = String(value).replace(/[,\s ₹]/g, '');
  if (text === '') return null;
  // Number('') and Number('0x10') are both accepted by Number(); neither is a figure.
  if (!/^[-+]?(\d+\.?\d*|\.\d+)(e[-+]?\d+)?$/i.test(text)) return NaN;
  return Number(text);
}

/** True when the entry is blank (null from parseNumber). */
export const isBlank = (value) => parseNumber(value) === null;

/** True when the entry is a usable number. */
export const isFiniteNumber = (value) => Number.isFinite(parseNumber(value));
